export default ({ commit }) => {
  return new Promise((resolve, reject) => {
    let message = {
      action: 'getInfo'
    }
    window.top.postMessage(JSON.stringify(message), '*')
    window.addEventListener('message', (e) => {
      console.log(e)
      let data = JSON.parse(e.data).data
      commit('setShappyInfo', data)
      resolve(data)
    }, false)
  })
}
